import { z } from "zod";

export const headerSearchBarSchema = z.object({
  search: z.string({ required_error: "Campo obrigatório" }).min(1),
});

export type HeaderSearchBarFormValues = z.infer<typeof headerSearchBarSchema>;
